import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import "./_style.scss";
function Well({ children, look, className, ...other }) {
    return (_jsx("div", { ...other, className: classNames("well", { [`--${look}`]: look }, className), children: children }));
}
export default Well;
